import { render, staticRenderFns } from "./status-location.vue?vue&type=template&id=297bd0d5&"
import script from "./status-location.vue?vue&type=script&lang=js&"
export * from "./status-location.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports